module.exports = __webpack_public_path__ + "img/2.890442ac.png";